import { ReferenceTableData } from '@common/types';
import { ColumnOptionFunction } from '@common/types/components/table/common';

export const isCellUniqOptions = (options?: ReferenceTableData['options']): options is ColumnOptionFunction => {
  return Boolean(options) && typeof options === 'function';
};
